import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Home = () => import('@/views/home')
const Dashboard = () => import('@/views/dashboard')
const Wall = () => import('@/views/wall')
const Sprints = () => import('@/views/sprints')
const Boards = () => import('@/views/boards')
const Steps = () => import('@/views/steps')
const Issue = () => import('@/views/issue/show')
const IssueHistory = () => import('@/views/issue/history')


const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')



const pagination = () => import('@/views/pages/pagination')



const ContactAdd = () => import('@/views/contacts/create')
const ContactEdit = () => import('@/views/contacts/edit')
const ContactList = () => import('@/views/contacts/list')



// const ContactList = () => import('@/views/contacts/list')
// const ContactCreat = () => import('@/views/contacts/ContactCreate')


const OrderList = () => import('@/views/order/list')
const OrderRequest = () => import('@/views/order/request')
const OrderPayment = () => import('@/views/order/payment')
const OrderEdit = () => import('@/views/order/edit')



const ProductCategoryAdd = () => import('@/views/productCategory/create')
const ProductCategoryEdit = () => import('@/views/productCategory/edit')
const ProductCategoryList = () => import('@/views/productCategory/list')

const ProductAdd = () => import('@/views/product/create')
const ProductEdit = () => import('@/views/product/edit')
const ProductList = () => import('@/views/product/list')

const UnitAdd = () => import('@/views/unit/create')
const UnitEdit = () => import('@/views/unit/edit')
const UnitList = () => import('@/views/unit/list')



const ServiceCategoryAdd = () => import('@/views/serviceCategory/create')
const ServiceCategoryEdit = () => import('@/views/serviceCategory/edit')
const ServiceCategoryList = () => import('@/views/serviceCategory/list')

const AccountingCodeAdd = () => import('@/views/accountingCode/create')
const AccountingCodeEdit = () => import('@/views/accountingCode/edit')
const AccountingCodeList = () => import('@/views/accountingCode/list')


const ProjectAdd = () => import('@/views/project/create')
const ProjectEdit = () => import('@/views/project/edit')
const ProjectList = () => import('@/views/project/list')


const SprintAdd = () => import('@/views/sprint/create')
const SprintEdit = () => import('@/views/sprint/edit')
const SprintList = () => import('@/views/sprint/list')


const ProcessAdd = () => import('@/views/process/create')
const ProcessEdit = () => import('@/views/process/edit')
const ProcessList = () => import('@/views/process/list')

const StepAdd = () => import('@/views/step/create')
const StepEdit = () => import('@/views/step/edit')
const StepList = () => import('@/views/step/list')


const FieldAdd = () => import('@/views/field/create')
const FieldEdit = () => import('@/views/field/edit')
const FieldList = () => import('@/views/field/list')


const IssueTypeAdd = () => import('@/views/issueType/create')
const IssueTypeEdit = () => import('@/views/issueType/edit')
const IssueTypeList = () => import('@/views/issueType/list')




const FlowAdd = () => import('@/views/flow/create')
const FlowEdit = () => import('@/views/flow/edit')
const FlowList = () => import('@/views/flow/list')




const ServiceAdd = () => import('@/views/service/create')
const ServiceEdit = () => import('@/views/service/edit')
const ServiceList = () => import('@/views/service/list')



const UserAdd = () => import('@/views/userManage/create')
const UserEdit = () => import('@/views/userManage/edit')
const UserList = () => import('@/views/userManage/list')

const RoleAdd = () => import('@/views/rolesManager/create')
const RoleEdit = () => import('@/views/rolesManager/edit')
const RoleList = () => import('@/views/rolesManager/list')



const ContactProfile = () => import('@/views/contacts/profile')

const ManageIssues = () => import('@/views/product/list')

const ReportGeneralOrders = () => import('@/views/reports/report-new')
const ReportGeneralIncome = () => import('@/views/reports/report-new')
const ReportGeneralProjects = () => import('@/views/reports/report-new')



const LoadingAdd = () => import('@/views/loading/create')
const LoadingEdit = () => import('@/views/loading/edit')
const LoadingList = () => import('@/views/loading/list')



Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function guard(to, from, next) {
    if (localStorage.getItem('token')) {
        next(); // allow to enter route
    } else {
        next('/login'); // go to '/login';
    }
}

function loginSkip(to, from, next) {
    if (localStorage.getItem('token')) {
        next('/'); // go to '/login';
    } else {
        next(); // allow to enter route
    }
}



function configRoutes () {
  return [
      {
          path: "/login",
          name: "login",
          beforeEnter: loginSkip,
          component: Login
      },

    {
      path: '/',
      redirect: '/wall',  //temp //original:dashboard
      name: 'پنل',
      component: TheContainer,
      beforeEnter: guard,

        children: [

          {
            path: 'dashboard',
              redirect: '/wall',  //temp
              name: 'داشبورد',
            component: Home
            // component: Dashboard
          },

          {
            path: 'wall',
            name: 'تابلو کاری (Wall)',
            component: Home
            // component: Wall
          },

          {
            path: 'boards',
            name: 'میز کار (Boards)',
            component: Boards
          },

          {
            path: 'sprints',
            name: 'زمانبندی (Sprints)',
            component: Sprints
          },

          {
            path: 'processBoard/:id',
            name: 'چرخه فرایند',
            component: Steps
          },


          {
            path: 'issue/:id',
            name: 'نمایش Issue',
            component: Issue
          },
          {
            path: 'issue/history/:id',
            name: 'گذشته Issue',
            component: IssueHistory
          },




          {
          path: 'contact',
          redirect: '/contact/list',
          name: 'اطالاعات تماس',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/contact/list',
              name: 'مدیریت اطلاعات تماس',
              component: ContactList
            },
            {
              path: '/contact/create',
              name: 'افزودن سرنخ/فرصت/مشتری/تامین‌کننده',
              component: ContactAdd
            },
            {
              path: '/contact/edit/:id',
              name: 'ویرایش سرنخ/فرصت/مشتری/تامین‌کننده',
              component: ContactEdit
            },

            {
              path: '/contact/profile/:id',
              name: 'پروفایل',
              component: ContactProfile
            }
          ]
        },

          {
            path: 'product',
            redirect: '/product/list',
            name: ' کالا ها',
            component: {
              render (c) { return c('router-view') }
            },
            children: [



              {
                path: '/productCategory/list',
                name: 'مدیریت دسته کالا ها',
                component: ProductCategoryList
              },
              {
                path: '/productCategory/create',
                name: 'افزودن دسته کالا',
                component: ProductCategoryAdd
              },
              {
                path: '/productCategory/edit/:id',
                name: 'ویرایش دسته کالا',
                component: ProductCategoryEdit
              },




              {
                path: '/product/list',
                name: 'مدیریت کالا ها',
                component: ProductList
              },
              {
                path: '/product/create',
                name: 'افزودن کالا',
                component: ProductAdd
              },
              {
                path: '/product/edit/:id',
                name: 'ویرایش کالا',
                component: ProductEdit
              },


              {
                path: '/unit/list',
                name: 'مدیریت واحد ها',
                component: UnitList
              },
              {
                path: '/unit/create',
                name: 'افزودن واحد',
                component: UnitAdd
              },
              {
                path: '/unit/edit/:id',
                name: 'ویرایش واحد',
                component: UnitEdit
              },









            ]
          },

          {
            path: 'service',
            redirect: '/service/list',
            name: ' خدمات',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/service/list',
                name: 'مدیریت خدمات',
                component: ServiceList
              },
              {
                path: '/service/create',
                name: 'افزودن ',
                component: ServiceAdd
              },
              {
                path: '/service/edit/:id',
                name: 'ویرایش ',
                component: ServiceEdit
              },



              {
                path: '/serviceCategory/list',
                name: 'مدیریت دسته خدمات',
                component: ServiceCategoryList
              },
              {
                path: '/serviceCategory/create',
                name: 'افزودن ',
                component: ServiceCategoryAdd
              },
              {
                path: '/serviceCategory/edit/:id',
                name: 'ویرایش ',
                component: ServiceCategoryEdit
              }
            ]
          },

          {
            path: 'project',
            redirect: '/project/list',
            name: ' پروژه ها',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/project/list',
                name: 'مدیریت پروژه ها',
                component: ProjectList
              },
              {
                path: '/project/create',
                name: 'افزودن پروژه',
                component: ProjectAdd
              },
              {
                path: '/project/edit/:id',
                name: 'ویرایش پروژه',
                component: ProjectEdit
              },

              {
                path: '/project/show/:id',
                name: 'نمایش پروژه',
                component: ProjectList
              }
            ]
          },



          {
            path: 'sprint',
            redirect: '/sprint/list',
            name: ' Sprint ها',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/sprint/list',
                name: 'مدیریت Sprint ها',
                component: SprintList
              },
              {
                path: '/sprint/create',
                name: 'افزودن Sprint',
                component: SprintAdd
              },
              {
                path: '/sprint/edit/:id',
                name: 'ویرایش Sprint',
                component: SprintEdit
              },

              {
                path: '/sprint/show/:id',
                name: 'نمایش Sprint',
                component: SprintList
              }
            ]
          },



          {
            path: 'process',
            redirect: '/process/list',
            name: ' فرایند ها',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/process/list',
                name: 'مدیریت فرایند ها',
                component: ProcessList
              },
              {
                path: '/process/create',
                name: 'افزودن فرایند',
                component: ProcessAdd
              },
              {
                path: '/process/edit/:id',
                name: 'ویرایش فرایند',
                component: ProcessEdit
              },

              {
                path: '/process/show/:id',
                name: 'نمایش فرایند',
                component: ProcessList
              }
            ]
          },



          {
            path: 'step',
            redirect: '/process/list',
            name: ' فرایند ها',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/step/:id/list',
                name: 'مدیریت مرحله ها',
                component: StepList
              },
              {
                path: '/step/create',
                name: 'افزودن مرحله',
                component: StepAdd
              },
              {
                path: '/step/edit/:id',
                name: 'ویرایش مرحله',
                component: StepEdit
              },

              {
                path: '/step/show/:id',
                name: 'نمایش مرحله',
                component: StepList
              }
            ]
          },




          {
            path: 'accountingCode',
            redirect: '/accountingCode/list',
            name: ' کد های حسابدری ',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/accountingCode/list',
                name: 'مدیریت کد های حسابدری  ',
                component: AccountingCodeList
              },
              {
                path: '/accountingCode/create',
                name: 'افزودن کد حسابدری',
                component: AccountingCodeAdd
              },
              {
                path: '/accountingCode/edit/:id',
                name: 'ویرایش  کد حسابدری',
                component: AccountingCodeEdit
              }


            ]
          },

          {
          path: 'order',
          redirect: '/order/list',
          name: 'مدیریت مالی ',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '/order/list',
              name: 'مدیریت سفارش ها',
              component: OrderList
            },
              {
              path: '/order/request/:id',
              name: 'افزودن سفارش',
              component: OrderRequest
            },
            {
              path: '/order/payment/:id',
              name: 'پیش فاکتور / فاکتور',
              component: OrderPayment
            },

            {
              path: '/order/edit/:id',
              name: '  ویرایش فاکتور',
              component: OrderEdit
            },





            {
              path: '/loading/list',
              name: 'مدیریت ارسال (ورود/خروج انبار) ها',
              component: LoadingList
            },
            {
              path: '/loading/create',
              name: 'افزودن  ارسال (ورود/خروج انبار)',
              component: LoadingAdd
            },
            {
              path: '/loading/edit/:id',
              name: 'ویرایش  ارسال (ورود/خروج انبار)',
              component: LoadingEdit
            },




          ]
        },

          {
            path: 'user',
            redirect: '/user/list',
            name: ' کاربران',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/user/list',
                name: 'مدیریت کاربران',
                component: UserList
              },
              {
                path: '/user/create',
                name: 'افزودن ',
                component: UserAdd
              },
              {
                path: '/user/edit/:id',
                name: 'ویرایش ',
                component: UserEdit
              }
            ]
          },


          {
            path: 'role',
            redirect: '/role/list',
            name: ' نقش ها',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/role/list',
                name: 'مدیریت نقش ها',
                component: RoleList
              },
              {
                path: '/role/create',
                name: 'افزودن ',
                component: RoleAdd
              },
              {
                path: '/role/edit/:id',
                name: 'ویرایش ',
                component: RoleEdit
              }
            ]
          },







          {
            path: 'field',
            redirect: '/field/list',
            name: ' فیلد ها',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/field/list',
                name: 'مدیریت فیلد ها',
                component: FieldList
              },
              {
                path: '/field/create',
                name: 'افزودن فیلد',
                component: FieldAdd
              },
              {
                path: '/field/edit/:id',
                name: 'ویرایش فیلد',
                component: FieldEdit
              },

              {
                path: '/field/show/:id',
                name: 'نمایش فیلد',
                component: FieldList
              }
            ]
          },

          {
            path: 'issueType',
            redirect: '/issueType/list',
            name: ' Issue Types ',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/issueType/list',
                name: 'مدیریت  Issue Types ',
                component: IssueTypeList
              },
              {
                path: '/issueType/create',
                name: 'افزودن  Issue Type',
                component: IssueTypeAdd
              },
              {
                path: '/issueType/edit/:id',
                name: 'ویرایش  Issue Type',
                component: IssueTypeEdit
              },

              {
                path: '/issueType/show/:id',
                name: 'نمایش  Issue Type',
                component:  IssueTypeList
              }
            ]
          },



  {
            path: 'flow',
            redirect: '/flow/list',
            name: ' گردش کار (شروط و عملیات) ',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/flow/list',
                name: 'مدریت گردش ها (Flows)',
                component: FlowList
              },
              {
                path: '/flow/list/:id',
                name: 'مدریت گردش ها (Flows)',
                component: FlowList
              },
              {
                path: '/flow/create',
                name: 'ایجاد گردش (Flow)',
                component: FlowAdd
              },
              {
                path: '/flow/edit/:id',
                name: 'ویرایش گردش (Flow)',
                component: FlowEdit
              },


              {
                path: '/flow/show/:id',
                name: 'نمایش گردش (Flow)',
                component:  FlowList
              }
            ]
          },


















          {
            path: 'reports',
            // redirect: '/reports/',
            name: ' گزارشات',
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '/report/generalOrders',
                name: ' گزارش کلی سفارشات',
                component: ReportGeneralOrders
              },
              {
                path: '/report/generalOrders',
                name: ' گزارش کلی درامد هزینه',
                component: ReportGeneralIncome
              },

              {
                path: '/report/generalProjects',
                name: ' گزارش کلی پروژه',
                component: ReportGeneralProjects
              },

            ]
          },


















          {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'condition/list',
          redirect: '/condition/list',
          name: 'گردش کار',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'ایجاد',
              component: Forms
            },



            {
              path: '/condition/list',
              name: 'مدریت گردش و شروط',
              component: Forms
            },


            {
              path: 'manageIssues',
              name: 'مدریت گردش و شروط',
              component: ManageIssues
            },




            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },



    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }



  ]
}

